module.exports = __webpack_public_path__ + "static/media/close.c2e6aa40.svg";